/** Public URL for the Twido product logo (served from /public). */
export const TWIDO_LOGO_SRC = "/twido-logo.svg";

export const TWIDO_APP_NAME = "Twido";
